module.exports = __webpack_public_path__ + "img/icon-lugares.195fdece.svg";